import { create } from "zustand";

type SettingsStore = {
    tabSettings: string;
    setTabSettings: (tab: string) => void;

    templates: any[];
    setTemplates: (templates: any[]) => void;

    updateSettings: boolean;
    setUpdateSettings: (update: boolean) => void;

    jobOffers: any[];
    setJobOffers: (jobOffers: any[]) => void;

    formData: any;
    setFormData: (formData: any) => void;

    jobOfferID: number | undefined;
    setJobOfferID: (id: number | undefined) => void;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
    tabSettings: "",
    setTabSettings: (tab: string) => set({ tabSettings: tab }),

    templates: [],
    setTemplates: (templates: any[]) => set({ templates }),

    updateSettings: false,
    setUpdateSettings: (update: boolean) => set({ updateSettings: update }),

    jobOffers: [],
    setJobOffers: (jobOffers: any[]) => set({ jobOffers }),

    formData: {},
    setFormData: (formData: any) => set({ formData }),

    jobOfferID: undefined,
    setJobOfferID: (id: number | undefined) => set({ jobOfferID: id }),
}))